import { COMMON_CONSTANTS } from '@nile/components';
import shortid from 'shortid';

export const defaultPrimaryColor = ['#45A9F1', '#48AC3D'];
export const defaultSecondaryColor = '#E7E7F7';
export const defaultProgressState = {
  basicSetUp: {
    isCompleted: false
  },
  proactiveMSP: {
    isCompleted: false
  },
  troubleShoot: {
    isCompleted: false
  },
  manageYourTeam: {
    isCompleted: false
  },
  activeTask: null,
  demoDataCleared: false
};

export const tabs = [
  {
    id: 'basicSetUp',
    panelId: 'basicSetUp',
    // label: 'product.onboarding.basicSetUp.label'
    label: 'Basic Set Up'
  },
  {
    id: 'proactiveMSP',
    panelId: 'proactiveMSP',
    icon: 'LightBulb',
    label: 'product.onboarding.proactiveMSP.label'
  },
  {
    id: 'troubleShoot',
    panelId: 'troubleShoot',
    icon: 'MagicWand',
    label: 'product.onboarding.troubleShoot.label'
  },
  {
    id: 'manageYourTeam',
    panelId: 'manageYourTeam',
    icon: 'UserGroup',
    label: 'product.onboarding.manageYourTeam.label'
  }
];

export const dataMapList = {
  [COMMON_CONSTANTS.IT]: {
    basicSetUp: {
      tasks: [
        {
          id: 'setUpBasics',
          icon: 'HomePlain',
          title: 'product.onboarding.basicSetUp.setUpBasics.label',
          subTasks: [
            'inviteYourTeam',
            'buildYourMSP',
            'domainEmailConfig',
            'deployAgent',
            'manageSecurity'
          ],
          bubbleMessage: {
            greetUser: true,
            content: 'product.onboarding.basicSetUp.setUpBasics.bubbleMessage'
          }
        }
      ],
      subTasks: [
        'inviteYourTeam',
        'buildYourMSP',
        'domainEmailConfig',
        'deployAgent',
        'manageSecurity'
      ]
    },
    proactiveMSP: {
      tasks: [
        {
          id: 'proactiveMSP',
          icon: 'LightBulb',
          title: 'product.onboarding.proactiveMSP.label',
          subTasks: [
            'assetPolicies',
            'softWareBundle',
            'eventTriggers',
            'timeTriggers'
          ],
          bubbleMessage: {
            content:
              'product.onboarding.proactiveMSP.proactiveMSP.bubbleMessage'
          }
        }
      ],
      subTasks: [
        'assetPolicies',
        'softWareBundle',
        'eventTriggers',
        'timeTriggers'
      ]
    },
    troubleShoot: {
      tasks: [
        {
          id: 'troubleshoot',
          icon: 'MagicWand',
          title: 'product.onboarding.troubleShoot.troubleshoot.label',
          subTasks: [
            'valuableContext',
            'networkMonitoring',
            'manageFields',
            'runbooks',
            'createTemplate'
          ],
          bubbleMessage: {
            content: 'itsm.onboarding.troubleshooting.bubble.content'
          }
        },
        {
          id: 'delightClients',
          icon: 'Delight',
          title: 'itsm.onboarding.delight.heading',
          subTasks: ['manageNotification', 'sla', 'systemTray'],
          bubbleMessage: {
            greetUser: true,
            content:
              'product.onboarding.troubleShoot.delightClients.bubbleMessage'
          }
        }
      ],
      subTasks: [
        'valuableContext',
        'networkMonitoring',
        'manageFields',
        'runbooks',
        'createTemplate',
        'manageNotification',
        'sla',
        'systemTray'
      ]
    },
    manageYourTeam: {
      tasks: [
        {
          id: 'manageTeam',
          icon: 'UserGroup',
          title: 'product.onboarding.manageYourTeam.manageTeam.label',
          subTasks: ['techPermission'],
          bubbleMessage: {
            content:
              'product.onboarding.manageYourTeam.manageTeam.bubbleMessage'
          }
        },
        {
          id: 'getToScale',
          icon: 'WeighScale',
          title: 'product.onboarding.manageYourTeam.getToScale.label',
          subTasks: ['project', 'reports'],
          bubbleMessage: {
            greetUser: true,
            content:
              'product.onboarding.manageYourTeam.getToScale.bubbleMessage'
          }
        }
      ],
      subTasks: ['techPermission', 'invoiceAudit', 'project', 'reports']
    }
  },
  [COMMON_CONSTANTS.MSP]: {
    basicSetUp: {
      tasks: [
        {
          id: 'setUpBasics',
          icon: 'HomePlain',
          title: 'product.onboarding.basicSetUp.setUpBasics.label',
          subTasks: [
            'inviteYourTeam',
            'buildYourMSP',
            'domainEmailConfig',
            'createClient',
            'deployAgent',
            'manageSecurity'
          ],
          bubbleMessage: {
            greetUser: true,
            content: 'product.onboarding.basicSetUp.setUpBasics.bubbleMessage'
          }
        }
      ],
      subTasks: [
        'inviteYourTeam',
        'buildYourMSP',
        'domainEmailConfig',
        'createClient',
        'deployAgent',
        'manageSecurity'
      ]
    },
    proactiveMSP: {
      tasks: [
        {
          id: 'proactiveMSP',
          icon: 'LightBulb',
          title: 'product.onboarding.proactiveMSP.label',
          subTasks: [
            'assetPolicies',
            'softWareBundle',
            'contracts',
            'deliverymap'
          ],
          bubbleMessage: {
            content:
              'product.onboarding.proactiveMSP.proactiveMSP.bubbleMessage'
          }
        },
        {
          id: 'predictableRevenue',
          icon: 'TargetGoal',
          title: 'product.onboarding.proactiveMSP.predictableRevenue.label',
          subTasks: [
            'serviceCatalog',
            'timeTracking',
            'invoiceSetting',
            'profitability'
          ],
          bubbleMessage: {
            greetUser: true,
            content:
              'product.onboarding.proactiveMSP.predictableRevenue.bubbleMessage'
          }
        }
      ],
      subTasks: [
        'assetPolicies',
        'softWareBundle',
        'contracts',
        'deliverymap',
        'profitability',
        'serviceCatalog',
        'timeTracking',
        'invoiceSetting'
      ]
    },
    troubleShoot: {
      tasks: [
        {
          id: 'troubleshoot',
          icon: 'MagicWand',
          title: 'product.onboarding.troubleShoot.troubleshoot.label',
          subTasks: [
            'valuableContext',
            'networkMonitoring',
            'manageFields',
            'runbooks',
            'eventTriggers',
            'createTemplate'
          ],
          bubbleMessage: {
            content:
              'product.onboarding.troubleShoot.troubleshoot.bubbleMessage'
          }
        },
        {
          id: 'delightClients',
          icon: 'Delight',
          title: 'product.onboarding.troubleShoot.delightClients.label',
          subTasks: ['manageNotification', 'sla', 'timeTriggers', 'systemTray'],
          bubbleMessage: {
            greetUser: true,
            content:
              'product.onboarding.troubleShoot.delightClients.bubbleMessage'
          }
        }
      ],
      subTasks: [
        'valuableContext',
        'networkMonitoring',
        'manageFields',
        'runbooks',
        'eventTriggers',
        'createTemplate',
        'manageNotification',
        'sla',
        'timeTriggers',
        'systemTray'
      ]
    },
    manageYourTeam: {
      tasks: [
        {
          id: 'manageTeam',
          icon: 'UserGroup',
          title: 'product.onboarding.manageYourTeam.manageTeam.label',
          subTasks: ['techPermission', 'scheduleAndDispatch', 'invoiceAudit'],
          bubbleMessage: {
            content:
              'product.onboarding.manageYourTeam.manageTeam.bubbleMessage'
          }
        },
        {
          id: 'getToScale',
          icon: 'WeighScale',
          title: 'product.onboarding.manageYourTeam.getToScale.label',
          subTasks: ['project', 'reports'],
          bubbleMessage: {
            greetUser: true,
            content:
              'product.onboarding.manageYourTeam.getToScale.bubbleMessage'
          }
        }
      ],
      subTasks: [
        'techPermission',
        'scheduleAndDispatch',
        'invoiceAudit',
        'project',
        'reports'
      ]
    }
  }
};

export const SubTasksMapList = {
  [COMMON_CONSTANTS.MSP]: {
    inviteYourTeam: {
      explore: '/onboard/employee',
      readTime: '2',
      buttons: [
        {
          type: 'button',
          label: 'product.onboarding.explore.inviteYourTeam.btn'
        }
      ]
    },
    buildYourMSP: {
      explore: '/onboard/mspinformation',
      readTime: '2'
      // buttons: [
      //   {
      //     type: 'button',
      //     label: 'product.onboarding.explore.buildYourMSP.btn'
      //   }
      // ]
    },
    domainEmailConfig: {
      explore: '/onboard/mailserver',
      readTime: '2',
      buttons: [
        {
          type: 'button',
          label: 'app.common.continue'
          // icon: 'Save'
        }
      ]
    },
    createClient: {
      title: 'product.onboarding.task.createClientAndDeployAgent.title',
      readTime: '2',
      description:
        'product.onboarding.task.createClientAndDeployAgent.description',
      explore: { url: 'clientViews/3002/client-list', task: 'createClient' },
      buttons: [
        {
          type: 'link',
          label: 'dromo.client.import.title',
          task: 'import',
          id: 'CLIENT'
        },
        {
          type: 'button',
          label: 'onboarding.client.createClient.label',
          task: 'createClient'
        }
      ]
    },
    deployAgent: {
      title: 'product.onboarding.task.createClientAndDeployAgent.title',
      description:
        'product.onboarding.task.createClientAndDeployAgent.description',
      explore: { url: '/rmm/asset-view/4001', task: 'deployAgent' }
      // buttons: [
      //   {
      //     type: 'link',
      //     label: 'product.onboarding.import.deployAgent.btn',
      //     task: 'import',
      //     id: 'ASSET'
      //   }
      // ]
    },
    manageSecurity: {
      explore: '/onboard/technicianlogin',
      readTime: '2',
      buttons: [{ type: 'button', label: 'common.save' }]
    },
    assetPolicies: {
      explore: '/onboard/policymgmt-new',
      content: 'product.onboarding.task.assetPolicies.content.html',
      readTime: '1',
      buttons: [
        {
          type: 'button',
          label: 'product.onboarding.explore.policy.btn',
          url: '/onboard/policymgmt-new'
        }
      ]
    },
    softWareBundle: {
      explore: '/onboard/softwarebundle',
      content: true,
      readTime: '1',
      buttons: [
        {
          type: 'button',
          label: 'product.onboarding.explore.softWareBundle.btn',
          url: '/onboard/softwarebundle'
        }
      ]
    },
    serviceCatalog: {
      explore: '/onboard/serviceCatalog',
      content: true,
      readTime: '1',
      buttons: [
        {
          type: 'link',
          label: 'product.onboarding.import.serviceCatalog.btn',
          task: 'import',
          id: 'SERVICE_ITEM'
        },
        {
          type: 'button',
          label: 'product.onboarding.explore.serviceCatalog.btn',
          url: '/onboard/serviceCatalog'
        }
      ]
    },
    contracts: {
      explore: { url: '/contractViews/1/Contract templates', task: 'contacts' },
      content: true,
      readTime: '1',
      buttons: [
        {
          type: 'link',
          label: 'migrate.data.clientcontract.title',
          task: 'import',
          id: 'CLIENTCONTRACT'
        },
        {
          type: 'button',
          label: 'product.onboarding.explore.contracts.btn',
          task: 'contacts',
          url: '/contractViews/1/All contracts'
        }
      ]
    },
    timeTracking: {
      explore: '/onboard/timetracking',
      content: true,
      readTime: '1',
      buttons: [
        {
          type: 'button',
          label: 'product.onboarding.explore.timeTracking.btn',
          url: '/onboard/timetracking'
        }
      ]
    },
    invoiceSetting: {
      explore: '/onboard/invoicesettings',
      readTime: '1',
      buttons: [
        {
          type: 'button',
          label: 'common.save',
          icon: 'Save'
        }
      ]
    },
    valuableContext: {
      explore: { url: '/rmm/asset-view/4001', task: 'deployAgent' },
      content: true,
      readTime: '1',
      buttons: [
        {
          type: 'button',
          label: 'app.common.explore',
          url: '/rmm/asset-view/4001',
          task: 'deployAgent'
        }
      ]
    },
    networkMonitoring: {
      explore: { url: '/rmm/network-view/6001', task: 'networkMonitoring' },
      content: true,
      readTime: '1',
      buttons: [
        {
          type: 'button',
          label: 'app.common.explore',
          url: '/rmm/network-view/6001',
          task: 'networkMonitoring'
        }
      ]
    },
    manageFields: {
      explore: '/onboard/customfields',
      content: true,
      readTime: '1',
      buttons: [
        {
          type: 'link',
          label: 'product.onboarding.create.manageFields.btn',
          url: '/onboard/customfields'
        },
        {
          type: 'button',
          label: 'app.common.continue'
        }
      ]
    },
    runbooks: {
      explore: '/onboard/sop',
      content: true,
      readTime: '1',
      buttons: [
        {
          type: 'button',
          label: 'app.common.explore',
          url: '/onboard/sop'
        }
      ]
    },
    eventTriggers: {
      explore: '/onboard/eventtriggers',
      content: true,
      readTime: '1',
      buttons: [
        {
          type: 'button',
          label: 'app.common.explore',
          url: '/onboard/eventtriggers'
        }
      ]
    },
    createTemplate: {
      explore: '/onboard/templates',
      readTime: '1',
      // buttons: [
      //   {
      //     type: 'button',
      //     label: 'app.common.explore',
      //     url: '/onboard/templates'
      //   }
      // ],
      hideHeaderButtons: true,
      buttons: [
        {
          id: 'ticketTemplate',
          type: 'button',
          label: 'product.onboarding.explore.createTemplate.ticketTemplate.btn',
          url: `/onboard/formbuilder/${shortid.generate()}/new`
        },
        {
          id: 'taskTemplate',
          type: 'button',
          label: 'product.onboarding.explore.createTemplate.taskTemplate.btn',
          url: `/onboard/tasktemplate/${shortid.generate()}/new`
        },
        {
          id: 'projectTemplate',
          type: 'button',
          label:
            'product.onboarding.explore.createTemplate.projectTemplate.btn',
          url: `/onboard/projecttemplate/${shortid.generate()}/new`
        }
      ]
    },
    manageNotification: {
      explore: '/onboard/notificationcenter',
      content: true,
      hideHeaderButtons: true,
      readTime: '1',
      buttons: [
        {
          id: 'systemNotification',
          type: 'button',
          task: 'manageNotification',
          label: 'app.common.explore',
          url: '/onboard/notificationcenter'
        },
        {
          id: 'ticketNotification',
          type: 'button',
          task: 'manageNotification',
          label: 'app.common.explore',
          url: '/onboard/notificationcenter'
        },
        {
          id: 'clientNotification',
          type: 'button',
          task: 'manageNotification',
          label: 'app.common.explore',
          url: '/onboard/notificationcenter'
        }
      ]
    },
    sla: {
      explore: '/onboard/sla',
      readTime: '1',
      buttons: [
        {
          type: 'plainButton',
          label: 'product.onboarding.create.sla.btn',
          icon: 'add',
          url: `/onboard/sla/${shortid.generate()}/new`
        },
        {
          type: 'button',
          label: 'common.save'
        }
      ]
    },
    timeTriggers: {
      explore: '/onboard/timetriggers',
      readTime: '1',
      buttons: [
        {
          type: 'plainButton',
          label: 'common.create',
          icon: 'add',
          url: `/onboard/timetrigger/${shortid.generate()}/new`
        },
        {
          type: 'button',
          label: 'app.common.continue'
        }
      ]
    },
    systemTray: {
      explore: '/onboard/systemtray',
      readTime: '1',
      buttons: [
        {
          type: 'button',
          // label: 'app.common.continue',
          label: 'common.save'
          // url: '/onboard/systemtray'
        }
      ]
    },
    techPermission: {
      explore: '/onboard/technicianrole',
      detailedDescription:
        'product.onboarding.task.techPermission.content.html',
      content: true,
      hideHeaderButtons: true,
      readTime: '1',
      buttons: [
        {
          id: 'techRoles',
          type: 'button',
          label: 'app.common.explore',
          url: '/onboard/technicianrole'
        },
        {
          id: 'techGroups',
          type: 'button',
          label: 'app.common.explore',
          url: '/onboard/techniciangroup'
        }
      ]
    },
    invoiceAudit: {
      explore: {
        url: '/invoiceAuditViews/101/Invoice audit',
        task: 'invoiceAudit'
      },
      content: true,
      readTime: '1',
      buttons: [
        {
          type: 'button',
          label: 'app.common.explore',
          url: '/invoiceAuditViews/101/Invoice audit',
          task: 'invoiceAudit'
        }
      ]
    },
    project: {
      explore: { url: '/project/6/project-list', task: 'project' },
      content: true,
      readTime: '1',
      buttons: [
        {
          type: 'button',
          label: 'app.common.explore',
          task: 'project',
          url: '/project/6/project-list'
        }
      ]
    },
    reports: {
      explore: { url: '/report/1/view', task: 'reports' },
      content: true,
      readTime: '1',
      buttons: [
        {
          type: 'button',
          label: 'app.common.explore',
          task: 'reports',
          url: '/report/1/view'
        }
      ]
    },
    scheduleAndDispatch: {
      flag: 'scheduling',
      explore: { url: '/scheduling', task: 'scheduling' },
      content: true,
      readTime: '1',
      buttons: [
        {
          type: 'button',
          label: 'product.onboarding.explore.scheduleAndDispatch.btn',
          task: 'scheduling',
          url: '/scheduling'
        }
      ]
    },
    deliverymap: {
      content: true,
      readTime: '1'
    },
    profitability: {
      content: true,
      readTime: '2'
    }
  },
  [COMMON_CONSTANTS.IT]: {
    inviteYourTeam: {
      explore: '/onboard/employee',
      readTime: '2',
      buttons: [
        {
          type: 'button',
          label: 'itsm.product.onboarding.explore.inviteYourTeam.btn'
        }
      ]
    },
    buildYourMSP: {
      title: 'itsm.onboarding.organisation.heading',
      explore: '/onboard/mspinformation',
      readTime: '2'
      // buttons: [
      //   {
      //     type: 'button',
      //     label: 'product.onboarding.explore.buildYourMSP.btn'
      //   }
      // ]
    },
    domainEmailConfig: {
      explore: '/onboard/mailserver',
      readTime: '2',
      description: 'itsm.domain.email.subheading',
      buttons: [
        {
          type: 'button',
          label: 'app.common.continue'
          // icon: 'Save'
        }
      ]
    },
    deployAgent: {
      title: 'itsm.onboarding.deploy.agent',
      description: 'itsm.onboarding.deploy.agent.description',
      explore: { url: '/rmm/asset-view/4001', task: 'deployAgent' }
      // buttons: [
      //   {
      //     type: 'link',
      //     label: 'product.onboarding.import.deployAgent.btn',
      //     task: 'import',
      //     id: 'ASSET'
      //   }
      // ]
    },
    manageSecurity: {
      explore: '/onboard/technicianlogin',
      readTime: '2',
      buttons: [{ type: 'button', label: 'common.save' }]
    },
    assetPolicies: {
      explore: '/onboard/policymgmt-new',
      content: 'product.onboarding.task.assetPolicies.content.html',
      readTime: '1',
      buttons: [
        {
          type: 'button',
          label: 'product.onboarding.explore.policy.btn',
          url: '/onboard/policymgmt-new'
        }
      ]
    },
    softWareBundle: {
      explore: '/onboard/softwarebundle',
      description: 'itsm.onboarding.software.bundle.description',
      content: 'itsm.onboarding.software.bundle.content',
      readTime: '1',
      buttons: [
        {
          type: 'button',
          label: 'product.onboarding.explore.softWareBundle.btn',
          url: '/onboard/softwarebundle'
        }
      ]
    },
    serviceCatalog: {
      explore: '/onboard/serviceCatalog',
      content: true,
      readTime: '1',
      buttons: [
        {
          type: 'link',
          label: 'product.onboarding.import.serviceCatalog.btn',
          task: 'import',
          id: 'SERVICE_ITEM'
        },
        {
          type: 'button',
          label: 'product.onboarding.explore.serviceCatalog.btn',
          url: '/onboard/serviceCatalog'
        }
      ]
    },
    timeTracking: {
      explore: '/onboard/timetracking',
      content: true,
      readTime: '1',
      buttons: [
        {
          type: 'button',
          label: 'product.onboarding.explore.timeTracking.btn',
          url: '/onboard/timetracking'
        }
      ]
    },
    valuableContext: {
      explore: { url: '/rmm/asset-view/4001', task: 'deployAgent' },
      content: true,
      readTime: '1',
      imageName: 'valuableContext_IT',
      buttons: [
        {
          type: 'button',
          label: 'app.common.explore',
          url: '/rmm/asset-view/4001',
          task: 'deployAgent'
        }
      ]
    },
    networkMonitoring: {
      explore: { url: '/rmm/network-view/6001', task: 'networkMonitoring' },
      content: true,
      readTime: '1',
      imageName: 'networkMonitoring_IT',
      buttons: [
        {
          type: 'button',
          label: 'app.common.explore',
          url: '/rmm/network-view/6001',
          task: 'networkMonitoring'
        }
      ]
    },
    manageFields: {
      explore: '/onboard/customfields',
      description: 'itsm.onboarding.manage.field.description',
      content: 'itsm.onboarding.manage.field.details',
      readTime: '1',
      buttons: [
        {
          type: 'link',
          label: 'product.onboarding.create.manageFields.btn',
          url: '/onboard/customfields'
        },
        {
          type: 'button',
          label: 'app.common.continue'
        }
      ]
    },
    runbooks: {
      explore: '/onboard/sop',
      content: true,
      readTime: '1',
      imageName: 'runbooks_IT',
      buttons: [
        {
          type: 'button',
          label: 'app.common.explore',
          url: '/onboard/sop'
        }
      ]
    },
    eventTriggers: {
      explore: '/onboard/eventtriggers',
      content: true,
      readTime: '1',
      buttons: [
        {
          type: 'button',
          label: 'app.common.explore',
          url: '/onboard/eventtriggers'
        }
      ]
    },
    createTemplate: {
      explore: '/onboard/templates',
      readTime: '1',
      // buttons: [
      //   {
      //     type: 'button',
      //     label: 'app.common.explore',
      //     url: '/onboard/templates'
      //   }
      // ],
      hideHeaderButtons: true,
      buttons: [
        {
          id: 'ticketTemplate',
          type: 'button',
          label: 'product.onboarding.explore.createTemplate.ticketTemplate.btn',
          url: `/onboard/formbuilder/${shortid.generate()}/new`
        },
        {
          id: 'taskTemplate',
          type: 'button',
          label: 'product.onboarding.explore.createTemplate.taskTemplate.btn',
          url: `/onboard/tasktemplate/${shortid.generate()}/new`
        },
        {
          id: 'projectTemplate',
          type: 'button',
          label:
            'product.onboarding.explore.createTemplate.projectTemplate.btn',
          url: `/onboard/projecttemplate/${shortid.generate()}/new`
        }
      ]
    },
    manageNotification: {
      explore: '/onboard/notificationcenter',
      content: [
        'itsm.onboading.system.notifications.description',
        'itsm.onboading.ticket.notifications.description'
      ],
      description: 'itsm.onboarding.tech.notifications',
      hideHeaderButtons: true,
      readTime: '1',
      buttons: [
        {
          id: 'systemNotification',
          type: 'button',
          task: 'manageNotification',
          label: 'app.common.explore',
          url: '/onboard/notificationcenter'
        },
        {
          id: 'ticketNotification',
          type: 'button',
          task: 'manageNotification',
          label: 'app.common.explore',
          url: '/onboard/notificationcenter'
        }
      ]
    },
    sla: {
      explore: '/onboard/sla',
      readTime: '1',
      buttons: [
        {
          type: 'plainButton',
          label: 'product.onboarding.create.sla.btn',
          icon: 'add',
          url: `/onboard/sla/${shortid.generate()}/new`
        },
        {
          type: 'button',
          label: 'common.save'
        }
      ]
    },
    timeTriggers: {
      explore: '/onboard/timetriggers',
      readTime: '1',
      buttons: [
        {
          type: 'plainButton',
          label: 'common.create',
          icon: 'add',
          url: `/onboard/timetrigger/${shortid.generate()}/new`
        },
        {
          type: 'button',
          label: 'app.common.continue'
        }
      ]
    },
    systemTray: {
      explore: '/onboard/systemtray',
      description: 'itsm.onboarding.tray.description',
      readTime: '1',
      buttons: [
        {
          type: 'button',
          // label: 'app.common.continue',
          label: 'common.save'
          // url: '/onboard/systemtray'
        }
      ]
    },
    techPermission: {
      explore: '/onboard/technicianrole',
      detailedDescription:
        'product.onboarding.task.techPermission.content.html',
      content: true,
      hideHeaderButtons: true,
      readTime: '1',
      buttons: [
        {
          id: 'techRoles',
          type: 'button',
          label: 'app.common.explore',
          url: '/onboard/technicianrole'
        },
        {
          id: 'techGroupsForIT',
          itId: 'techGroups',
          type: 'button',
          label: 'app.common.explore',
          url: '/onboard/techniciangroup'
        }
      ]
    },
    project: {
      explore: { url: '/project/6/project-list', task: 'project' },
      content: true,
      readTime: '1',
      imageName: 'project_IT',
      buttons: [
        {
          type: 'button',
          label: 'app.common.explore',
          task: 'project',
          url: '/project/6/project-list'
        }
      ]
    },
    reports: {
      explore: { url: '/report/1/view', task: 'reports' },
      content: 'itsm.onboarding.reports.details',
      readTime: '1',
      buttons: [
        {
          type: 'button',
          label: 'app.common.explore',
          task: 'reports',
          url: '/report/1/view'
        }
      ]
    },
    scheduleAndDispatch: {
      flag: 'scheduling',
      explore: { url: '/scheduling', task: 'scheduling' },
      content: true,
      readTime: '1',
      buttons: [
        {
          type: 'button',
          label: 'product.onboarding.explore.scheduleAndDispatch.btn',
          task: 'scheduling',
          url: '/scheduling'
        }
      ]
    }
  }
};

export const planBasedTasks = {
  PSA: [
    'inviteYourTeam',
    'buildYourMSP',
    'domainEmailConfig',
    'createClient',
    // 'deployAgent',
    'manageSecurity',
    'contracts',
    'deliverymap',
    'profitability',
    'serviceCatalog',
    'timeTracking',
    'invoiceSetting',
    'manageFields',
    'runbooks',
    'eventTriggers',
    'createTemplate',
    'manageNotification',
    'sla',
    'timeTriggers',
    'techPermission',
    'invoiceAudit',
    'project',
    'reports'
  ],
  RMM: [
    'inviteYourTeam',
    'buildYourMSP',
    'domainEmailConfig',
    'createClient',
    'deployAgent',
    'manageSecurity',
    'assetPolicies',
    'softWareBundle',
    'valuableContext',
    'networkMonitoring',
    'systemTray',
    'reports'
  ],
  PSAANDRMM: [
    'inviteYourTeam',
    'buildYourMSP',
    'domainEmailConfig',
    'createClient',
    'deployAgent',
    'manageSecurity',
    'contracts',
    'deliverymap',
    'profitability',
    'manageFields',
    'runbooks',
    'eventTriggers',
    'createTemplate',
    'manageNotification',
    'sla',
    'timeTriggers',
    'techPermission',
    'invoiceAudit',
    'project',
    'assetPolicies',
    'softWareBundle',
    'serviceCatalog',
    'timeTracking',
    'invoiceSetting',
    'valuableContext',
    'networkMonitoring',
    'systemTray',
    'reports',
    'scheduleAndDispatch'
  ]
};
